module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3604-b2b172b3373ea8dd98360cc9cec534fd.jpg";